import { SidebarTrigger } from "@/components/ui/sidebar";
import RBreadcrumb from "@/components/RComponents/RBreadcrumb";
import RFlex from "@/components/RComponents/RFlex";
import { DashboardContext } from "@/layouts/DashboardLayout";
import { Separator } from "@radix-ui/react-separator";
import { Globe } from "lucide-react";
import { useContext } from "react";
import RDropdown from "@/components/RComponents/RDropDown";
import NotificationBell from "@/views/notifications/components/NotificationBell";

const RNavbar = () => {
  const dashboardContext = useContext(DashboardContext);

  return (
    <header
      id="header"
      className="shadow-md border-b-[1px] sticky top-0 bg-background flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 z-[5] justify-between"
    >
      <div id="trigger/breadcrumb" className="flex items-center gap-2 px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <RBreadcrumb />
      </div>
      <RFlex
        id="language/theme"
        className="gap-4 mx-8"
      >
        {/* {dashboardContext?.theme === "main-theme-dark" ? (
          <Sun
            className="w-4 h-4 hover:text-muted-foreground cursor-pointer"
            onClick={() =>
              dashboardContext &&
              dashboardContext.toggleTheme("main-theme-light")
            }
          />
        ) : (
          <Moon
            className="w-4 h-4 hover:text-muted-foreground cursor-pointer"
            onClick={() =>
              dashboardContext &&
              dashboardContext.toggleTheme("main-theme-dark")
            }
          />
        )} */}

        <NotificationBell />

        <RDropdown
          triggerComponent={<Globe className="w-5 h-5 hover:text-muted-foreground cursor-pointer" />}
          side="bottom"
          contentClassName="w-24"
          actions={[
            {
              name: "English",
              onClick: () => dashboardContext?.switchLanguage("en"),
              component: (
                <span className={dashboardContext?.activeLanguage === "en" ? "bg-muted w-full py-1 px-2 rounded ltr:text-left rtl:text-right" : "py-1 px-2 ltr:text-left rtl:text-right"}>
                  English
                </span>
              )
            },
            {
              name: "Arabic",
              onClick: () => dashboardContext?.switchLanguage("ar"),
              component: (
                <span className={dashboardContext?.activeLanguage === "ar" ? "bg-muted w-full py-1 px-2 rounded ltr:text-left rtl:text-right" : "py-1 px-2 ltr:text-left rtl:text-right"}>
                  Arabic
                </span>
              )
            }
          ]}
        />
      </RFlex>
    </header>
  );
};

export default RNavbar;
